/* tslint:disable */
/* eslint-disable */
/**
 * SelmaSME API
 * This definition is the API between customer SME-Gui and the persistence layer for the application NOT FOR V1 When customer logg-in to Selma-EN, we will create a processId with applicant CustomerId (from BankID). When a customer added attachment to the application, we don\'t have a CaseId i LP, should we add a LP-Service to create/reserve a caseId to be able to attach a document to the caseId in DM.
 *
 * The version of the OpenAPI document: 0.7.4
 * Contact: developer@landshypotek.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorModel,
    ErrorModelFromJSON,
    ErrorModelToJSON,
} from '../models';

export interface FileUploadRequest {
    xProcessID: string;
    xAttachmentType?: FileUploadXAttachmentTypeEnum;
    upfile?: Array<Blob>;
}

/**
 * no description
 */
export class UploadsApi extends runtime.BaseAPI {

    /**
     * The file to upload.
     * Uploads a file.
     */
    async fileUploadRaw(requestParameters: FileUploadRequest): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.xProcessID === null || requestParameters.xProcessID === undefined) {
            throw new runtime.RequiredError('xProcessID','Required parameter requestParameters.xProcessID was null or undefined when calling fileUpload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xProcessID !== undefined && requestParameters.xProcessID !== null) {
            headerParameters['X-process-ID'] = String(requestParameters.xProcessID);
        }

        if (requestParameters.xAttachmentType !== undefined && requestParameters.xAttachmentType !== null) {
            headerParameters['X-attachmentType'] = String(requestParameters.xAttachmentType);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("application", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.upfile) {
            formParams.append('upfile', requestParameters.upfile.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        const response = await this.request({
            path: `/v1/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * The file to upload.
     * Uploads a file.
     */
    async fileUpload(requestParameters: FileUploadRequest): Promise<object> {
        const response = await this.fileUploadRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum FileUploadXAttachmentTypeEnum {
    SKOGSBRUKSPLAN = 'SKOGSBRUKSPLAN',
    ANSTLLNINGSBEVIS = 'ANSTÄLLNINGSBEVIS',
    EUSTD = 'EU-STÖD'
}
